import { createSelector } from '../reselect';
import { getNewStats, total, simpleChart, safeDivide, simpleChart2 } from '../generalUtils';

const providerId = 'criteo';

const criteoSpend = createSelector([getNewStats], (stats) => total(stats[providerId], 'spend'));

const criteoSpendChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'spend')
);

const criteoConversionValue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'conversion_value')
);
const criteoConversionValueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'conversion_value')
);

const criteoVisits = createSelector([getNewStats], (stats) => total(stats[providerId], 'visits'));

const criteoVisitsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'visits')
);

const criteoClicks = createSelector([getNewStats], (stats) => total(stats[providerId], 'clicks'));

const criteoClicksChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'clicks')
);

const criteoDisplays = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'impressions')
);
const criteoDisplaysChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'impressions')
);

const criteoConversions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'conversions')
);
const criteoConversionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'conversions')
);

const criteoRoas = createSelector(
  [criteoConversionValue, criteoSpend],
  (criteoConversionValue, criteoSpend) => {
    return safeDivide(criteoConversionValue, criteoSpend);
  }
);
const criteoRoasChart = createSelector(
  [criteoConversionValueChart, criteoSpendChart],
  (criteoConversionValueChart, criteoSpendChart) =>
    simpleChart2(criteoConversionValueChart, criteoSpendChart)
);

const criteoConversionRate = createSelector(
    [criteoConversions, criteoVisits],
    (criteoConversions, criteoVisits) => {
      return safeDivide(100 * criteoConversions, criteoVisits);
    }
  );

  const criteoConversionRateChart = createSelector(
    [criteoConversionsChart, criteoVisitsChart],
    (criteoConversionsChart, criteoVisitsChart) =>
      simpleChart2(criteoConversionsChart, criteoVisitsChart, { chart1yMultiplier: 100 })
  );
  
  const criteoAverageOrderValue = createSelector(
    [criteoConversionValue, criteoConversions],
    (criteoConversionValue, criteoConversions) => {
      return safeDivide(criteoConversionValue, criteoConversions);
    }
  );
  
  const criteoAverageOrderValueChart = createSelector(
    [criteoConversionValueChart, criteoConversionsChart],
    (criteoConversionValueChart, criteoConversionsChart) =>
      simpleChart2(criteoConversionValueChart, criteoConversionsChart)
  );
  
  const criteoCostPerAcquisition = createSelector(
    [criteoSpend, criteoConversions],
    (criteoSpend, criteoConversions) => {
      return safeDivide(criteoSpend, criteoConversions);
    }
  );
  
  const criteoCostPerAcquisitionChart = createSelector(
    [criteoSpendChart, criteoConversionsChart],
    (criteoSpendChart, criteoConversionsChart) =>
      simpleChart2(criteoSpendChart, criteoConversionsChart)
  );
  
  const criteoCostPerVisit = createSelector(
    [criteoSpend, criteoVisits],
    (criteoSpend, criteoVisits) => {
      return safeDivide(criteoSpend, criteoVisits);
    }
  );
  
  const criteoCostPerVisitChart = createSelector(
    [criteoSpendChart, criteoVisitsChart],
    (criteoSpendChart, criteoVisitsChart) => simpleChart2(criteoSpendChart, criteoVisitsChart)
  );
  

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    criteoSpend,
    criteoSpendChart,
    criteoRoas,
    criteoRoasChart,
    criteoDisplays,
    criteoDisplaysChart,
    criteoClicks,
    criteoClicksChart,
    criteoVisits,
    criteoVisitsChart,
    criteoConversions,
    criteoConversionsChart,
    criteoConversionRate,
    criteoConversionRateChart,
    criteoAverageOrderValue,
    criteoAverageOrderValueChart,
    criteoCostPerAcquisition,
    criteoCostPerAcquisitionChart,
    criteoCostPerVisit,
    criteoCostPerVisitChart,
    criteoConversionValue,
    criteoConversionValueChart,
  },
};
